import { render, staticRenderFns } from "./HappyNewYear.vue?vue&type=template&id=a60899b4&scoped=true&"
import script from "./HappyNewYear.vue?vue&type=script&lang=js&"
export * from "./HappyNewYear.vue?vue&type=script&lang=js&"
import style0 from "./HappyNewYear.vue?vue&type=style&index=0&id=a60899b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60899b4",
  null
  
)

export default component.exports